import { DialogComponent } from '@theme/dialog';
import { CartAddEvent, CartUpdateEvent, ThemeEvents } from '@theme/events';
import cartProgressIndicator from './cart-progress-indicator.js';
import cartAutoDiscount from './cart-auto-discount.js';
import './confetti.js'; // Initialize confetti manager

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    console.log('🚀 Cart Drawer initialized');
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    document.addEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
    
    // Initialize progress indicator on first load
    this.#updateProgressIndicator();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    document.removeEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
  }

  #handleCartAdd = () => {
    console.log('🛍️  CartAddEvent received!');
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
    // Update progress indicator and check for auto-discount
    this.#updateProgressIndicator();
    cartAutoDiscount.checkAndApply();
  };

  #handleCartUpdate = () => {
    console.log('🔄 CartUpdateEvent received!');
    // Update progress indicator when cart updates
    this.#updateProgressIndicator();
    cartAutoDiscount.checkAndApply();
  };

  #updateProgressIndicator() {
    // Delay slightly to ensure DOM is updated
    setTimeout(() => {
      cartProgressIndicator.fetchAndUpdate();
    }, 100);
  }

  open() {
    this.showDialog();
    
    // Update progress indicator when drawer opens
    this.#updateProgressIndicator();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
